import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../../services/ui/global-settings.service';
import { SiteNote } from '../../models/site-notes/site-note.model';
import { SiteNotesService } from '../../services/sections/site-notes/site-notes.service';

@Injectable({
	providedIn: 'root'
})
export class SiteNotesListResolver implements Resolve<Observable<SiteNote[]>> {

	constructor(
		private router: Router,
		private siteNotesService: SiteNotesService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		let jobId = +activatedRouteSnapshot.paramMap.get('jobId');
		let params = {		
			assignedToMe: false,
			jobId: jobId,
			notCompleted: true,
			numberOfDays: null,
			searchQuery: ""};


		return this.siteNotesService.getSiteNotesList(activatedRouteSnapshot.paramMap.get('token'), params)
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
